import { get, patch } from "../../ApiService";
import { ApiUrl, SsoApiUrl } from "../../ApiUrl";

export const getCurrentUserData = async () => {
  try {
    const res = await get(SsoApiUrl.userManagement.userCurrent);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getCurrentUserPreferences = async () => {
  try {
    const res = await get(`${ApiUrl.profileModule.userPreferences}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateUserPreferences = async (body: any) => {
  try {
    const res = await patch(`${ApiUrl.profileModule.userPreferences}`, body);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getUserPreferencesOptions = async () => {
  return Promise.all([
    get(ApiUrl.preferences.languages),
    get(ApiUrl.preferences.dateFormats),
    get(ApiUrl.preferences.timeFormats),
    get(ApiUrl.preferences.calenderDays),
  ]);
};
